module.exports = __webpack_public_path__ + "img/tip-cup.7af2e44b.png";